import { MapPin, Calendar, ArrowLeft, ArrowRight, Home, Tag } from "lucide-react";
import { useState } from "react";
import house11 from '../assets/house1/1.jpg';
import house12 from '../assets/house1/2.jpg';
import house13 from '../assets/house1/3.jpg';
import house21 from '../assets/house2/1.jpg'
import house22 from '../assets/house2/2.jpg'
import house23 from '../assets/house2/3.jpg'
import house31 from '../assets/house3/1.jpg'
import house41 from '../assets/house4/1.jpeg';

import building1 from '../assets/building1/1.jpg'
import building2 from '../assets/building1/2.jpg'
import building3 from '../assets/building1/3.jpg'
export default function ProjectsPage() {
  const [selectedCategory, setSelectedCategory] = useState("Все");
  const [hoveredProject, setHoveredProject] = useState(null);
  const [imageIndex, setImageIndex] = useState({});

  // const projects = [
  //   {
  //     id: 1,
  //     title: "Республика Адыгея",
  //     location: "Майкоп",
  //     year: "2024",
  //     category: "Жилые",
  //     image:
  //       house11,
  //     budget: "$850K",
  //     duration: "8 месяцев",
  //     description:
  //       "Современная вилла с видом на озеро, умным домом и решениями по устойчивому развитию.",
  //     details: [
  // "Современная система умного дома",
  //       "Энергоэффективные решения",
  //       "Панорамные виды",
  //       "Роскошная отделка",
  //     ],
  //   },
  //   {
  //     id: 2,
  //     title: "Офисный комплекс в центре",
  //     location: "Центр города",
  //     year: "2023",
  //     category: "Коммерческие",
  //     image:
  //       building1,
  //     budget: "$2.5M",
  //     duration: "12 месяцев",
  //     description:
  //       "Современный коммерческий комплекс с удобным доступом и продуманным дизайном.",
  //     details: [
  //       "5-этажное здание",
  //       "Сертификация LEED",
  //       "Современные офисные помещения",
  //       "Парковочные места",
  //     ],
  //   },
  //   {
  //     id: 3,
  //     title: "Роскошный горный коттедж",
  //     location: "Горная долина",
  //     year: "2024",
  //     category: "Жилые",
  //     image:
  //       house21,
  //     budget: "$1.2M",
  //     duration: "10 месяцев",
  //     description:
  //       "Эксклюзивный горный коттедж, совмещающий современный комфорт и природную эстетику.",
  //     details: [
  //       "Горные виды",
  //       "Частные подъездные пути",
  //       "Гостевые домики",
  //       "Зоны для отдыха на свежем воздухе",
  //     ],
  //   },
  //   {
  //     id: 4,
  //     title: "Экологичное поселение",
  //     location: "Зелёные луга",
  //     year: "2023",
  //     category: "Жилые",
  //     image:
  //       "https://images.pexels.com/photos/2635038/pexels-photo-2635038.jpeg?auto=compress&cs=tinysrgb&w=800",
  //     budget: "$4M",
  //     duration: "18 месяцев",
  //     description:
  //       "Устойчивая община из 50 энергоэффективных домов с озеленёнными зонами и инфраструктурой.",
  //     details: [
  //       "50 домов",
  //       "Солнечная энергия",
  //       "Зелёные зоны",
  //       "Общий центр",
  //     ],
  //   },
  //   {
  //     id: 5,
  //     title: "Реконструкция торгового центра",
  //     location: "Центр города",
  //     year: "2023",
  //     category: "Коммерческие",
  //     image:
  //       "https://images.pexels.com/photos/2148596/pexels-photo-2148596.jpeg?auto=compress&cs=tinysrgb&w=800",
  //     budget: "$3M",
  //     duration: "14 месяцев",
  //     description:
  //       "Полная реконструкция торгового центра с современным дизайном и улучшенным опытом для посетителей.",
  //     details: [
  //       "Современный дизайн",
  //       "Новые магазины",
  //       "Улучшенные сервисы",
  //       "Повышенная доступность",
  //     ],
  //   },
  //   {
  //     id: 6,
  //     title: "Жилой комплекс",
  //     location: "Пригородные холмы",
  //     year: "2024",
  //     category: "Жилые",
  //     image:
  //       "https://images.pexels.com/photos/1721933/pexels-photo-1721933.jpeg?auto=compress&cs=tinysrgb&w=800",
  //     budget: "$2M",
  //     duration: "15 месяцев",
  //     description:
  //       "Многофункциональный жилой комплекс с апартаментами, таунхаусами и удобствами.",
  //     details: [
  //       "200+ единиц",
  //       "Бассейн",
  //       "Тренажёрный зал",
  //       "Паркинг",
  //     ],
  //   },
  // ];
const projects = [
    {
      title: "Республика Адыгея",
      location: "Майкоп",
      year: "2025",
      area: 120,
      price:`от 5,500,000 ₽`,
      images: [house31],
      category: "Жилые",
    },
    {
      title: "Республика Адыгея",
      location: "Майкоп",
      year: "2025",
      area: 110,
      price: `от 4,500,000 ₽`,
      images: [house21, house22, house23],
      category: "Жилые",
    },
    {
      title: "Республика Адыгея",
      location: "Майкоп",
      year: "2026",
      area: 680,
      price: `от 19,000,000 ₽`,
      images: [building1, building2, building3],
      category: "Коммерческие",
    },
    {
      title: "Республика Адыгея",
      location: "ГАВЕРДОВСКИЙ РАЙОН",
      year: "2023",
      area: 95,
      price:`от 7,500,000 ₽`,
      images: [house41],
      category: "Жилые",
    },
  ];
  const categories = ["Все", "Жилые", "Коммерческие"];

  const filteredProjects =
    selectedCategory === "Все"
      ? projects
      : projects.filter((p) => p.category === selectedCategory);

 return (
  <div className="min-h-screen bg-[#fafaf9]">
    {/* Hero */}
    <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900  py-24 text-white sm:py-28 lg:py-40">
      
      

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          {/* <div className="mb-10 flex items-center gap-4">
            <span className="h-px w-12 bg-[#147f8f]" />
            <span className="text-sm font-bold uppercase tracking-[0.4em] text-[#76bb17]">
              Портфолио
            </span>
          </div> */}

          <h1 className="max-w-3xl text-5xl font-semibold leading-[1.04] tracking-[-0.05em] text-white md:text-6xl lg:text-7xl">
            Наши проекты
          </h1>

          <p className="mt-8 max-w-2xl text-xl leading-[1.7] text-slate-300 md:text-2xl">
            Ознакомьтесь с нашим портфолио завершённых проектов в жилом и
            коммерческом секторах.
          </p>
        </div>
      </div>
    </section>

    {/* Projects */}
    <section className="py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Filter */}
        <div className="mb-14 flex flex-wrap items-center justify-center gap-3">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`rounded-sm border px-7 py-3 text-sm font-semibold uppercase tracking-[0.16em] transition duration-300 ${
                selectedCategory === category
                  ? "border-[#147f8f] bg-[#147f8f] text-white"
                  : "border-slate-200 bg-white text-slate-600 hover:border-[#147f8f] hover:text-[#147f8f]"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Grid */}
        {/* Grid */}
<div className="grid gap-8 md:grid-cols-2">
  {filteredProjects.map((project, index) => (
    <article
      key={index}
      className="group overflow-hidden rounded-sm border border-slate-200 bg-white transition duration-300 hover:border-[#147f8f]/40 hover:shadow-xl"
      onMouseEnter={() => {
        setHoveredProject(index);
        setImageIndex({ ...imageIndex, [index]: imageIndex[index] || 0 });
      }}
      onMouseLeave={() => setHoveredProject(null)}
    >
      {/* Image */}
      <div className="relative h-[340px] overflow-hidden bg-slate-200 sm:h-[380px]">
        <img
          src={project.images[imageIndex[index] || 0]}
          alt={project.title}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/45 via-slate-950/5 to-transparent" />

        <div className="absolute left-5 top-5 rounded-sm bg-white/90 px-4 py-2 text-xs font-bold uppercase tracking-[0.18em] text-slate-950 backdrop-blur">
          {project.category}
        </div>

        {project.images.length > 1 && (
          <>
            <button
              type="button"
              className="absolute left-5 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-sm border border-white/20 bg-slate-950/30 text-white backdrop-blur transition hover:bg-white hover:text-slate-950"
              onClick={(e) => {
                e.stopPropagation();
                const prevIndex = (imageIndex[index] || 0) - 1;
                setImageIndex({
                  ...imageIndex,
                  [index]:
                    prevIndex < 0 ? project.images.length - 1 : prevIndex,
                });
              }}
            >
              <ArrowLeft className="h-5 w-5" />
            </button>

            <button
              type="button"
              className="absolute right-5 top-1/2 z-20 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-sm border border-white/20 bg-slate-950/30 text-white backdrop-blur transition hover:bg-white hover:text-slate-950"
              onClick={(e) => {
                e.stopPropagation();
                const nextIndex = (imageIndex[index] || 0) + 1;
                setImageIndex({
                  ...imageIndex,
                  [index]: nextIndex % project.images.length,
                });
              }}
            >
              <ArrowRight className="h-5 w-5" />
            </button>
          </>
        )}

        {project.images.length > 1 && (
          <div className="absolute bottom-5 left-5 right-5 z-20 flex gap-2">
            {project.images.map((_, slideIndex) => (
              <button
                key={slideIndex}
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setImageIndex({
                    ...imageIndex,
                    [index]: slideIndex,
                  });
                }}
                className={`h-px flex-1 transition ${
                  slideIndex === (imageIndex[index] || 0)
                    ? "bg-[#76bb17]"
                    : "bg-white/45"
                }`}
              />
            ))}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-7 sm:p-8 lg:p-10">
        <div className="mb-6 flex items-start justify-between gap-6">
          <div>
            <p className="mb-3 text-xs font-bold uppercase tracking-[0.24em] text-[#147f8f]">
              {String(index + 1).padStart(2, "0")}
            </p>

            <h3 className="text-2xl font-semibold tracking-[-0.03em] text-slate-950 transition group-hover:text-[#147f8f]">
              {project.title}
            </h3>
          </div>

          <span className="hidden h-px w-16 bg-slate-200 sm:block" />
        </div>

        <div className="grid gap-4 text-sm text-slate-600 sm:grid-cols-2">
          <div className="flex items-center gap-3">
            <MapPin className="h-4 w-4 text-[#147f8f]" />
            <span>{project.location}</span>
          </div>

          <div className="flex items-center gap-3">
            <Calendar className="h-4 w-4 text-[#147f8f]" />
            <span>{project.year}</span>
          </div>

          <div className="flex items-center gap-3">
            <Home className="h-4 w-4 text-[#147f8f]" />
            <span>{project.area} м²</span>
          </div>

          <div className="flex items-center gap-3">
            <Tag className="h-4 w-4 text-[#147f8f]" />
            <span className="font-semibold text-slate-950">
              {project.price}
            </span>
          </div>
        </div>
      </div>
    </article>
  ))}
</div>
      </div>
    </section>
  </div>
);
}
